export enum GenericAvailabilityStatus {
  AVAILABLE = 'AVAILABLE',
  RESTRICTED = 'RESTRICTED',
}
